import { IconDefaultProfile } from 'assets/icons';
import React, { useState } from 'react';

interface Props {
  src: string;
  alt: string;
  alternativeImg?: string;
  style?: React.CSSProperties;
}

function ImgComponent({ src, alt, alternativeImg, style }: Props) {
  const [isImageError, setIsImageError] = useState(false);

  return src && !isImageError ? (
    <img
      data-type="thumbnail"
      alt={alt}
      src={src}
      onError={() => setIsImageError(true)}
      style={style}
    />
  ) : alternativeImg ? (
    <img
      data-type="thumbnail"
      alt={alt}
      src={alternativeImg}
      onError={() => setIsImageError(true)}
      style={style}
    />
  ) : (
    <div style={style}>
      <IconDefaultProfile width={52} height={52} />
    </div>
  );
}

export default ImgComponent;
